const SidebarData = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
  },
  {
    label: "Leads",
    icon: "mdi mdi-account-convert-outline",
    isHasArrow: true,
    url: "/leads",
  },
  {
    label: "Listas de Contactos",
    icon: "mdi mdi-account-group-outline",
    isHasArrow: true,
    url: "/contact-lists",
  },
  {
    label: "Campañas",
    icon: "mdi mdi-bullhorn-outline",
    isHasArrow: true,
    url: "/campaigns",
  },
  {
    label: "Automatizaciones",
    icon: "mdi mdi-cogs",
    isHasArrow: true,
    subItem: [
      { sublabel: "Flujos de Trabajo", link: "/automation/workflows" },
      { sublabel: "Historial", link: "/automation/executions" },
    ],
  },
  {
    label: "Actividad de Contactos",
    icon: "mdi mdi-calendar-clock",
    isHasArrow: true,
    url: "/events",
  },
  {
    label: "Calendario",
    icon: "mdi mdi-calendar-outline",
    isHasArrow: true,
    subItem: [
      { sublabel: "Vista de Calendario", link: "/calendar" },
      { sublabel: "Configurar Proveedores", link: "/calendar-providers" },
    ],
  },
  {
    label: "Email Marketing",
    icon: "mdi mdi-email-multiple-outline",
    subItem: [
      { sublabel: "Plantillas de Email", link: "/email-templates" },
      { sublabel: "Verificar Emails", link: "/email-validation" },
      { sublabel: "Configurar Envío", link: "/email-providers" },
    ],
  },
  {
    label: "Conversaciones",
    icon: "mdi mdi-whatsapp",
    url: "/conversations",
  },
  {
    label: "Plantillas",
    icon: "mdi mdi-file-document-multiple-outline",
    subItem: [
      { sublabel: "Conectar WhatsApp", link: "/whatsapp-providers" },
      { sublabel: "Plantillas de WhatsApp", link: "/whatsapp-templates" },
      { sublabel: "Páginas de Aterrizaje", link: "/landing-templates" },
    ],
  },
  {
    label: "Páginas",
    icon: "mdi mdi-file-document-edit-outline",
    isHasArrow: true,
    url: "/pages",
  },
  {
    label: "Identidad Corporativa",
    icon: "mdi mdi-palette-outline",
    isHasArrow: true,
    url: "/corporate-identity",
  },
  {
    label: "Equipos de Venta",
    icon: "mdi mdi-account-group",
    isHasArrow: true,
    subItem: [
      { sublabel: "Miembros", link: "/sales-teams/members" },
      { sublabel: "Equipos", link: "/sales-teams" },
    ],
    adminOnly: true, // Solo visible para administradores
  },
  // {
  //   label: "Calendar",
  //   icon: "mdi mdi-calendar-outline",
  //   isHasArrow: true,
  //   url: "/calendar",
  // },
  // {
  //   label: "AI",
  //   isMainMenu: true,
  // },
  // {
  //   label: "Chatbot Builder",
  //   icon: "mdi mdi-robot",
  //   isHasArrow: true,
  //   url: "/dashboard/bot-builder",
  // },
  // {
  //   label: "Email",
  //   icon: "mdi mdi-email-outline",
  //   subItem: [
  //     { sublabel: "Inbox", link: "/inbox" },
  //     { sublabel: "Read Email", link: "/read-email" },
  //     { sublabel: "Email Compose", link: "/compose-email" },
  //   ],
  // },
  // {
  //   label: "Pages",
  //   isMainMenu: true,
  // },

  // {
  //   label: "Components",
  //   isMainMenu: true,
  // },
  // {
  //   label: "UI Elements",
  //   icon: "mdi mdi-briefcase-variant-outline",
  //   subItem: [
  //     { sublabel: "Alerts", link: "/ui-alerts" },
  //     { sublabel: "Badge", link: "/ui-badge" },
  //     { sublabel: "Breadcrumb", link: "/ui-breadcrumb" },
  //     { sublabel: "Buttons", link: "/ui-buttons" },
  //     { sublabel: "Cards", link: "/ui-cards" },
  //     { sublabel: "Carousel", link: "/ui-carousel" },
  //     { sublabel: "Dropdowns", link: "/ui-dropdowns" },
  //     { sublabel: "Grid", link: "/ui-grid" },
  //     { sublabel: "Images", link: "/ui-images" },
  //     { sublabel: "Lightbox", link: "/ui-lightbox" },
  //     { sublabel: "Modals", link: "/ui-modals" },
  //     { sublabel: "Offcanvas", link: "/ui-offcanvas" },
  //     { sublabel: "Range Slider", link: "/ui-rangeslider" },
  //     { sublabel: "Session Timeout", link: "/ui-sessiontimeout" },
  //     { sublabel: "Pagination", link: "/ui-pagination" },
  //     { sublabel: "Progress Bars", link: "/ui-progressbars" },
  //     { sublabel: "Placeholders", link: "/ui-placeholders" },
  //     { sublabel: "Tabs & Accordions", link: "/ui-tabs-accordions" },
  //     { sublabel: "Typography", link: "/ui-typography" },
  //     { sublabel: "Toasts", link: "/ui-toasts" },
  //     { sublabel: "Video", link: "/ui-video" },
  //     { sublabel: "Popovers & Tooltips", link: "/ui-popovers" },
  //     { sublabel: "Rating", link: "/ui-rating" },
  //   ],
  // },
  // {
  //   label: "Forms",
  //   icon: "ri-eraser-fill",
  //   issubMenubadge: true,
  //   bgcolor: "bg-danger",
  //   badgeValue: "8",
  //   subItem: [
  //     { sublabel: "Form Elements", link: "/form-elements" },
  //     { sublabel: "Form Validation", link: "/form-validation" },
  //     { sublabel: "Form Advanced Plugins", link: "/form-advanced" },
  //     { sublabel: "Form Editor", link: "/form-editor" },
  //     { sublabel: "Form File Upload", link: "/form-uploads" },
  //     { sublabel: "Form X-editable", link: "/form-editors" },
  //     { sublabel: "Form Wizard", link: "/form-wizard" },
  //     { sublabel: "Form Mask", link: "/form-mask" },
  //   ],
  // },
  // {
  //   label: "Tables",
  //   icon: "ri-table-2",
  //   subItem: [
  //     { sublabel: "Basic Tables", link: "/tables-basic" },
  //     { sublabel: "List Js", link: "/tables-listjs" },
  //     { sublabel: "React Datatables", link: "/table-datatables" },
  //   ],
  // },
  // {
  //   label: "Charts",
  //   icon: "ri-bar-chart-line",
  //   subItem: [
  //     { sublabel: "Apex Charts", link: "/chart-apexcharts" },
  //     { sublabel: "Chartjs Charts", link: "/chart-chartjscharts" },
  //     { sublabel: "Re Charts", link: "/chart-floatcharts" },
  //     { sublabel: "Knob Charts", link: "/chart-jknobcharts" },
  //     { sublabel: "Sparkline Charts", link: "/chart-sparklinecharts" },
  //   ],
  // },
  // {
  //   label: "Icons",
  //   icon: "ri-brush-line",
  //   subItem: [
  //     { sublabel: "Box Icons", link: "/icon-boxicon" },
  //     { sublabel: "Material Design", link: "/icons-materialdesign" },
  //     { sublabel: "Dripicons", link: "/icon-dripicons" },
  //     { sublabel: "Font Awesome", link: "/icons-fontawesome" },
  //   ],
  // },
  // {
  //   label: "Maps",
  //   icon: "ri-map-pin-line",
  //   subItem: [
  //     { sublabel: "Google Maps", link: "/maps-google" },
  //     { sublabel: "Vector Maps", link: "/maps-vector" },
  //   ],
  // },
  // {
  //   label: "Multi Level",
  //   icon: "ri-share-line",
  //   subItem: [
  //     { sublabel: "Level 1.1", link: "/#" },
  //     {
  //       sublabel: "Level 1.2",
  //       link: "/#",
  //       subMenu: [{ title: "Level 2.1" }, { title: "Level 2.2" }],
  //     },
  //   ],
  // },
];
export default SidebarData;
